var map = {
	"./write-CUHK.svg": 48105,
	"./write-HKU.svg": 58943,
	"./write-UST.svg": 57870,
	"./write-arrow.svg": 41709,
	"./write-image-CUHK.svg": 116,
	"./write-image-HKU.svg": 60761,
	"./write-image-UST.svg": 91376,
	"./write-plus-CUHK.svg": 74612,
	"./write-plus-HKU.svg": 22691,
	"./write-plus-UST.svg": 66288,
	"./write-public-CUHK.svg": 63634,
	"./write-public-HKU.svg": 57257,
	"./write-public-UST.svg": 27945,
	"./write-realname-CUHK.svg": 11106,
	"./write-realname-HKU.svg": 22442,
	"./write-realname-UST.svg": 95286,
	"./write-topic-CUHK.svg": 1963,
	"./write-topic-HKU.svg": 39817,
	"./write-topic-UST.svg": 6909,
	"./write-uni-CUHK.svg": 95227,
	"./write-uni-HKU.svg": 70338,
	"./write-uni-UST.svg": 14223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1207;